export default "__VITE_ASSET__1666f5fe__"